import { render, staticRenderFns } from "./SerpTab.vue?vue&type=template&id=5f0c8508&scoped=true"
import script from "./SerpTab.vue?vue&type=script&lang=js"
export * from "./SerpTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c8508",
  null
  
)

export default component.exports